import {useDispatch} from 'react-redux';

import {ActionTypes} from 'nutshell-core/session/session-types';
import {Nut_Settings_User} from 'nutshell-core/settings-constants';

import {resyncSidebarCollapseClasses} from '../../../resync-sidebar-collapse-classes';

import {useUpdateUserSetting} from '../../core/use-update-user-setting';

export function useSidebarCollapse() {
    const dispatch = useDispatch();
    const updateSetting = useUpdateUserSetting();

    const setSidebarCollapsed = (userId: string, shouldCollapse: boolean) => {
        const value = shouldCollapse ? '1' : '0';

        updateSetting({
            userId,
            settingName: Nut_Settings_User.SETTING_MAIN_SIDEBAR_COLLAPSED,
            value,
            propertyOnUser: 'isMainSidebarCollapsed',
        });

        dispatch({
            type: ActionTypes.SESSION_UPDATE_MAIN_SIDEBAR_COLLAPSED,
            payload: {
                isMainSidebarCollapsed: shouldCollapse,
            },
        });

        resyncSidebarCollapseClasses(shouldCollapse);
    };

    return setSidebarCollapsed;
}
